// @flow
// $FlowFixMe
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';
import { getBaseURL } from '@finect/front-utils/env';
import { H4, H6 } from '@finect/tabular-core/Headings';
import { OptionCard } from './../SubscribeModal/components';
import { getTrialFromMetadata, isTrialWindowOpen } from '../../utils/Plus/trial';

const Container = styled.div`
  padding: 0 20px 40px 20px;

  > h4,
  > h6 {
    margin-left: 20px;
  }

  p {
    margin: 0 0 10px;
    font-size: 14px;
  }
`;

type Props = {
  user: Object
};

export const PlusArticleCard = (props: Props) => {
  const paymentUrl = `/servicios/finect-plus/comprar`;

  const buyUrl = props.user.isLoggedIn ? `${paymentUrl}` : `${getLoginBaseURL()}?next=${getBaseURL() + paymentUrl}`;

  // La duración del free trial sale de la metadata del producto Plus (no hardcodeada).
  // Priorizamos la del segmento profesional (50103), que es a quien va dirigida esta línea.
  const [trial, setTrial] = useState(null);
  useEffect(() => {
    finectAPI({
      version: 'v4',
      path: 'products/finect-plus',
      method: 'GET',
      onSuccess: ({ data }: { data: Object }) =>
        setTrial(getTrialFromMetadata(data?.entity?.metadata, { professional: true })),
      onError: () => {}
    });
  }, []);

  // Igual que los badges de promo: solo se muestra mientras la ventana del trial siga abierta.
  const showTrialLine = Boolean(trial && trial.months && isTrialWindowOpen(trial));

  return (
    <Container>
      <H4>¡Vaya! Este contenido es solo para miembros Plus.</H4>
      <H6>
        ✅ Actualiza a <b>Finect Plus</b> para acceder a este y a muchos otros contenidos exclusivos.
      </H6>
      {showTrialLine && trial && (
        <H6 style={{ paddingLeft: '19px' }}>
          Además, si eres profesional del sector podrás disfrutar de{' '}
          <b>
            {trial.months} {trial.months === 1 ? 'mes' : 'meses'} gratis
          </b>
          .
        </H6>
      )}
      <OptionCard plus option="basic" url={buyUrl} />
    </Container>
  );
};
